/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2025-05-21 10:41:18
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2026-07-03 14:23:58
 * @FilePath: \crane-safety-manager\src\pages\Dashboard\Top5AlarmTypesByDailyCount.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Empty } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import usecustomStyles from '../../Common/customStyles';
import * as SThunk from '../../slices/statistics/thunk';

const customStyles = usecustomStyles();

const Top5AlarmTypesByDailyCount = ({ style, vehicleListData }) => {
    const alarmType = useSelector(state => state.Statistics.alarmType);
    const user = useSelector(state => state.Login.user);
    const [alarmTypes, setAlarmTypes] = useState([]);
    const payload = {
        'role': user.user?.role || '',
        "startDate": moment().startOf('day').format('YYYY-MM-DD'),
        "endDate": moment().format('YYYY-MM-DD'),
    }

    const dispatch = useDispatch();
    useEffect(() => {
        // 只有当 alarmType 为空时才调用 API，避免页面刷新重复查询
        if (!Object.keys(alarmType).length) {
            dispatch(SThunk.alarmType(payload));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let countList = _.entries(alarmType).map(x => ({ name: x[0], value: x[1] }));
        countList = _.orderBy(countList, ['value', 'name'], ['desc', 'asc']);
        const topList = countList.map((item,i) => (
            <li key={item.name} className='card-list-li'>
                <div style={{ display: 'flex', justifyContent:'space-between' }}>
                    <span>
                        <span style={{ margin: '0.5em' }}>{i + 1}.</span> <span>{item.name}</span>
                    </span> {' '}
                    <b style={{ marginRight: '0.5em' }}>{item.value}</b>
                </div>
            </li>
        ));

        setAlarmTypes(topList);
    }, [alarmType, vehicleListData]);

    const EmptyItem = <Empty image="/nodata.png" description={<span></span>} style={{ padding: '10%' }} />;
    return (
        <Card title="(今日)报警类型 - TOP 5" style={style}>
            {alarmTypes && alarmTypes.length > 0 ? <ul style={{ listStyleType: 'none', padding: 0 }}>{alarmTypes}</ul> : EmptyItem}
        </Card>
    );
};

export default Top5AlarmTypesByDailyCount;
